export const defaultVideoDetailConfig = {
  sections: ['LatestMediaByShow', 'RecommendedMedia']
};